<template>
  <div class="main-page process">
    <Menus title="我的留言咨询" :home="true">
      <a @click="$router.push('/service/10')" href="javascript:;" slot="left-link" />
    </Menus>
    <div class="container-flex">
      <div class="process-list">
        <div v-if="!list.length && loadover" class="pageStateTip">
          <div class="imgs">
            <img src="/img/ui/legal-default.png" alt>
          </div>
          <div class="ht">
            <h1>您还没有进行过留言咨询</h1>
          </div>
        </div>
        <div class="m-list-item" v-for="(item, index) in list" :key="'key-' + index">
          <h4>
            {{ item.message_category | getMessageName }}
          </h4>
          <p>地区： {{ item.area_parent ? item.area_parent + '-' + item.area_sub : item.area_sub }}</p>
          <p>咨询人类型： {{ item.message_user_type | getMessageName }}</p>
          <p>咨询详细描述：{{ item.question }} </p>
          <p>咨询答复：{{ item.answer || '-' }} </p>
          <p>咨询时间：{{ item.created }}</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Menus from '@/components/Menu'
import { getCookie } from '../../datas/js/common'
export default {
  components: { Menus },
  computed: {
    userinfo () {
      return this.$store.state.user.wechatUinfo
    },
    posturl () {
      return 'https://yn.12348.laway.cn'
      // return 'https://dev.12348.laway.cn'
    }
  },
  filters: {
    getMessageName (val) {
      return val.map(v => v.name).join('、')
    }
  },
  data () {
    return {
      list: [],
      loadover: false
    }
  },
  mounted () {
    // if (!this.userinfo.userid) {
    //   this.$router.push('/advisory/message/info?url=/advisory/message/list')
    //   return
    // }
    this.getList()
  },
  methods: {
    async getList () {
      const exatrParams = {
        withCredentials: true
      }
      let { status, result } = await this.$get(`${this.posturl}/pufa/api/proxy/?type=message&per_page=10000000&page=1&create_user=${this.userinfo.userid}`, this, '', exatrParams)
      this.loadover = true
      if (status) {
        this.list = result.data
      }
    },

  },
}
</script>
<style lang="stylus" scoped>
.m-list-item
  width 8rem
  padding 0.3rem 0.5rem
  background-color rgba(252, 255, 255, 0.2)
  border-radius 0.08rem
  border solid 1px rgba(255, 255, 255, 0.2)
  color #fff
  letter-spacing 1px
  line-height 1.6
  font-size 0.24rem
  margin 0.3rem auto
  h4
    margin-bottom 0.15rem
    font-size 0.32rem
    line-height 1.2
</style>
